import { ProductInfoBox as CoreProductInfoBox } from 'core/components'
import { TmrProduct } from 'stylewhere/api'
import { OperationConfig } from 'stylewhere/shared'
import { getProductBarcodeValue } from 'custom/cucinelli/shared/utils'

export class ProductInfoBox extends CoreProductInfoBox {
  getProductCode(product?: TmrProduct): string {
    if (!product) return '---'

    const operation = (this.props as any).operation as OperationConfig | undefined
    const barcodeValue = getProductBarcodeValue(product, operation)
    return barcodeValue || '---'
  }
}
